import { queryClient } from "shared/api/queryClient";
import { usePaginationQuery } from "shared/hooks/usePaginationQuery";
import { TableSortModel } from "shared/types/tables";
import { getModuleTemplatePagedList } from "../api/getModuleTemplateList";
import { ModuleData } from "../types";

export const useModulePagedListQuery = (
  limit: number,
  page: { currentPage: number; prevPage: number },
  sortModel: TableSortModel,
) => {
  return usePaginationQuery<ModuleData>({
    queryKey: ["moduleTemplates"],
    limit,
    page,
    sortModel,
    queryFn: async (params) => {
      const pagedData = await getModuleTemplatePagedList(
        {
          limit,
          startListItem: params.pageParam.startListItem,
          endListItem: params.pageParam.endListItem,
        },
        sortModel,
      );

      return {
        items: pagedData,
        totalPages: Math.ceil(pagedData.totalCount / limit),
      };
    },
  });
};

export const invalidateModuleTemplatePagedListQuery = async () => {
  await queryClient.invalidateQueries({ queryKey: ["moduleTemplates"] });
};
